/*
  Kiwi Ears · KARS 2.0 + KVT page (Rene 2026-08-31) — sections/kv-*.

  IT TOGGLES MARKUP, IT NEVER BUILDS A PANEL. Every hero panel, diagram view,
  energy view and signal flow is server-rendered by its section; this file
  only decides which one shows. Loaded by several sections, so the run-once
  guard is load-bearing.

  The KVT intensity slider was removed on 2026-09-15 (Rene: "remove the
  sliders, they are not of use anymore") — it drove the retired SVG's animation
  variables, so nothing reads them now.
*/
(function () {
  'use strict';
  if (window.__kiwiKars) return;
  window.__kiwiKars = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  var press = function (btns, active) {
    btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b === active)); });
  };

  /* -------------------------------------------------- hero: KARS ⇄ KVT */
  var hero = $('[data-kv-hero]');
  if (hero) {
    var heroBtns = $$('[data-kv-tech]', hero);
    hero.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kv-tech]');
      if (!b) return;
      press(heroBtns, b);
      $$('[data-kv-panel]', hero).forEach(function (p) {
        p.hidden = p.getAttribute('data-kv-panel') !== b.getAttribute('data-kv-tech');
      });
    });
  }

  /* ------------------------------------- KARS workbench: diagram views */
  var kars = $('[data-kv-kars]');
  if (kars) {
    var karsBtns = $$('[data-kv-view]', kars);
    kars.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kv-view]');
      if (!b) return;
      var view = b.getAttribute('data-kv-view');
      kars.setAttribute('data-kv-mode', view);
      press(karsBtns, b);
      /* Pictures replaced the schematic (Rene 2026-09-15): the active view's
         photograph crossfades in with its copy. */
      $$('[data-kv-shot]', kars).forEach(function (img) {
        img.classList.toggle('is-on', img.getAttribute('data-kv-shot') === view);
      });
      $$('[data-kv-copy]', kars).forEach(function (c) {
        c.hidden = c.getAttribute('data-kv-copy') !== view;
      });
    });
  }

  /* --------------------------------------- KVT workbench: energy views */
  var kvt = $('[data-kv-kvt]');
  if (kvt) {
    var kvtBtns = $$('[data-kv-energy-btn]', kvt);
    kvt.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kv-energy-btn]');
      if (!b) return;
      var view = b.getAttribute('data-kv-energy-btn');
      kvt.setAttribute('data-kv-energy', view);
      press(kvtBtns, b);
      $$('[data-kv-shot]', kvt).forEach(function (img) {
        img.classList.toggle('is-on', img.getAttribute('data-kv-shot') === view);
      });
      $$('[data-kv-energy-copy]', kvt).forEach(function (c) {
        c.hidden = c.getAttribute('data-kv-energy-copy') !== view;
      });
    });

  }

  /* ------------------------------------------------- signal-path tabs */
  var signal = $('[data-kv-signal]');
  if (signal) {
    var sigBtns = $$('[data-kv-flow]', signal);
    signal.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kv-flow]');
      if (!b) return;
      press(sigBtns, b);
      $$('[data-kv-flow-panel]', signal).forEach(function (p) {
        p.hidden = p.getAttribute('data-kv-flow-panel') !== b.getAttribute('data-kv-flow');
      });
    });
  }

  /* ------------------------------------------------------------ reveals */
  function reveals() {
    if (!window.gsap || !window.ScrollTrigger) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    window.gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', function () {
      $$('[data-kv-rev]').forEach(function (el) {
        window.gsap.fromTo(el, { autoAlpha: 0, y: 22 }, {
          autoAlpha: 1, y: 0, duration: 0.7, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 92%', once: true }
        });
      });
    });
  }
  if (window.gsap && window.ScrollTrigger) reveals();
  else {
    var tries = 0;
    var poll = setInterval(function () {
      if ((window.gsap && window.ScrollTrigger) || tries++ > 40) { clearInterval(poll); reveals(); }
    }, 100);
  }
})();
